export default "<div class=\"app-container__content\">\n  <router-outlet></router-outlet>\n</div>";